import React from "react"
import styles from "./TrackShipment.module.scss"
import FilterInTable from "../../../../../Manage/FilterInTable"
import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"

const data = [
  {
    id: 1,
    shipmentId: "SHIP-001",
    warehouse: "Warehouse A",
    shipmentDate: "11/07/2024",
    carrier: "FedEx",
    trackingNumber: "46457563",
    status: "In transit",
    action: "View",
  },
  {
    id: 2,
    shipmentId: "SHIP-001",
    warehouse: "Warehouse A",
    shipmentDate: "11/07/2024",
    carrier: "FedEx",
    trackingNumber: "46457563",
    status: "In transit",
    action: "View",
  },
  {
    id: 3,
    shipmentId: "SHIP-001",
    warehouse: "Warehouse A",
    shipmentDate: "11/07/2024",
    carrier: "FedEx",
    trackingNumber: "46457563",
    status: "Delivered",
    action: "View",
  },
  {
    id: 4,
    shipmentId: "SHIP-001",
    warehouse: "Warehouse A",
    shipmentDate: "11/07/2024",
    carrier: "FedEx",
    trackingNumber: "46457563",
    status: "Delivered",
    action: "View",
  },
  {
    id: 5,
    shipmentId: "SHIP-001",
    warehouse: "Warehouse A",
    shipmentDate: "11/07/2024",
    carrier: "FedEx",
    trackingNumber: "46457563",
    status: "In transit",
    action: "View",
  },
]

const columns = [
  {
    name: "Shipment ID",
    selector: (row) => row.shipmentId,
    sortable: true,
    minWidth: "160px",
  },
  {
    name: "Warehouse",
    selector: (row) => row.warehouse,
    sortable: true,
    minWidth: "140px",
  },
  {
    name: "Shipment Date",
    selector: (row) => row.shipmentDate,
    sortable: true,
    minWidth: "180px",
  },
  {
    name: "Carrier",
    selector: (row) => row.carrier,
    sortable: true,
    minWidth: "120px",
  },
  {
    name: "Tracking Number",
    selector: (row) => row.trackingNumber,
    sortable: true,
    minWidth: "200px",
  },
  {
    name: "Status",
    cell: (row) => <span className={getStatusClass(row.status)}>{row.status}</span>,
    sortable: true,
    minWidth: "120px",
  },
  {
    name: "Action",
    selector: (row) => <div className="cursor-pointer">{row.action}</div>,
  },
]

const getStatusClass = (status) => {
  switch (status.toLowerCase()) {
    case "in transit":
      return styles.statusInTransit
    case "delivered":
      return styles.statusDelivered
    default:
      return ""
  }
}

const TrackShipment = () => {
  return (
    <div className={styles.mainManageProductsContainer}>
      <h4 className={styles.sectionHeading}>Track Shipments</h4>

      <div className={styles.trackShipment}>
        <FilterInTable componentName={"Track Shipments"} />

        <div className={styles.shipmentTable}>
          <DatatableComponent columns={columns} data={data} pagination highlightOnHover type="yellow" />
        </div>
      </div>
    </div>
  )
}

export default TrackShipment
